var _tspan;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPetit = function SvgPetit(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Calque 1",
    viewBox: "0 0 164 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    style: {
      fontSize: "35.75px",
      fill: "#00e164",
      fontFamily: "GarageGothic-Bold",
      fontWeight: 700
    },
    transform: "translate(51.88 62.44)"
  }, "P", /*#__PURE__*/React.createElement("tspan", {
    x: 12.73,
    y: 0,
    style: {
      letterSpacing: ".01em"
    }
  }, "E"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 24.35,
    y: 0
  }, "TIT"))), /*#__PURE__*/React.createElement("rect", {
    width: 86.25,
    height: 50,
    x: 35.75,
    y: 25,
    rx: 25,
    style: {
      fill: "none",
      stroke: "#00e164",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPetit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/petit.42fc9b91afc5da61089955dcddd4f96a.svg";